"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BancoDoBrasilCheckNumberCalculator_1 = __importDefault(require("./CheckNumber/BancoDoBrasilCheckNumberCalculator"));
var CommonBankAccountValidator_1 = __importDefault(require("../CommonBankAccountValidator"));
var BancoDoBrasilValidator = /** @class */ (function (_super) {
    __extends(BancoDoBrasilValidator, _super);
    function BancoDoBrasilValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BancoDoBrasilValidator.prototype.agencyCheckNumberIsValid = function (agencyCheckNumber) {
        return agencyCheckNumber.length === this.agencyCheckNumberLength() && _super.prototype.agencyCheckNumberIsValid.call(this, agencyCheckNumber);
    };
    BancoDoBrasilValidator.prototype.accountNumberIsValid = function (accountNumber) {
        return accountNumber.length === this.accountNumberLength() && _super.prototype.accountNumberIsValid.call(this, accountNumber);
    };
    BancoDoBrasilValidator.prototype.agencyCheckNumberMatch = function (bankAccount) {
        var checkNumberCalculated = BancoDoBrasilCheckNumberCalculator_1.default.calculateAgency(bankAccount.agencyNumber);
        return checkNumberCalculated === bankAccount.agencyCheckNumber.toUpperCase();
    };
    BancoDoBrasilValidator.prototype.accountCheckNumberMatch = function (bankAccount) {
        var checkNumberCalculated = BancoDoBrasilCheckNumberCalculator_1.default.calculateAccount(bankAccount.accountNumber);
        return checkNumberCalculated === bankAccount.accountCheckNumber.toUpperCase();
    };
    BancoDoBrasilValidator.prototype.agencyCheckNumberLength = function () {
        return 1;
    };
    BancoDoBrasilValidator.prototype.accountNumberLength = function () {
        return 8;
    };
    BancoDoBrasilValidator.prototype.agencyNumberMsgError = function () {
        return _super.prototype.agencyNumberMsgError.call(this);
    };
    return BancoDoBrasilValidator;
}(CommonBankAccountValidator_1.default));
exports.default = BancoDoBrasilValidator;
//# sourceMappingURL=BancoDoBrasilValidator.js.map


//////////////////
// WEBPACK FOOTER
// ./~/br-bank-account-validator/dist/Validators/BancoDoBrasilValidator.js
// module id = 911
// module chunks = 2